import { useCallback } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { deleteCategory } from "../api/category.api";

export function useDeleteCategory() {
  const { run, loading } = useLatestRequest();

  const execute = useCallback(
    async (id: string): Promise<void> => {
      await run(async () => {
        await deleteCategory(id);
      });
    },
    [run],
  );

  return { execute, isLoading: loading };
}
